// 261023 E3-P3kc (SA NOTE 1) — «⋯» của thanh trên chỉ có MỘT khe, nhưng ba nơi cùng muốn đặt mục: bước (vd ① Quét lại), DANH SÁCH tập của ⑤ và TẬP đang mở.
// Mỗi nơi ghi vào nguồn RIÊNG (không đè nhau, cleanup của nơi này không xoá mục của nơi kia); vỏ GỘP: bước → danh sách → tập, giữa hai nhóm có đường kẻ. THUẦN, không antd/react.
export interface TopMenuExtra {
  key: string;
  label: string;
  danger?: boolean;
  disabled?: boolean;
  /** Lý do mờ — hiện ở tooltip của mục. */
  reason?: string;
  /** Nhóm (nguồn) của mục — `mergeTopMenu` điền; dùng để chèn đường kẻ giữa các nhóm. */
  group?: TopMenuSource;
  onSelect: () => void;
}

export type TopMenuSource = 'stage' | 'list' | 'episode';
export const TOP_MENU_ORDER: ReadonlyArray<TopMenuSource> = ['stage', 'list', 'episode'];

/** Gộp các nguồn theo `TOP_MENU_ORDER`. Khoá được tiền tố theo nguồn ⇒ hai nguồn dùng cùng khoá cũng không đè nhau. */
export const mergeTopMenu = (sources: Partial<Record<TopMenuSource, ReadonlyArray<TopMenuExtra>>>): TopMenuExtra[] =>
  TOP_MENU_ORDER.flatMap((src) => (sources[src] ?? []).map((x) => ({ ...x, key: `${src}.${x.key}`, group: src })));

/** Chèn `null` (= đường kẻ) giữa hai nhóm liền nhau khác nguồn. */
export const withGroupDividers = (items: ReadonlyArray<TopMenuExtra>): Array<TopMenuExtra | null> =>
  items.flatMap((x, i) => (i > 0 && items[i - 1].group !== x.group ? [null, x] : [x]));
